import { render, staticRenderFns } from "./MostProfitProducts.vue?vue&type=template&id=29c0b67f&scoped=true&"
import script from "./MostProfitProducts.vue?vue&type=script&lang=js&"
export * from "./MostProfitProducts.vue?vue&type=script&lang=js&"
import style0 from "./MostProfitProducts.vue?vue&type=style&index=0&id=29c0b67f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c0b67f",
  null
  
)

export default component.exports